<template>
  <v-btn-form :title="title" @close="cancel()" listable>
    <template v-if="!isEdit">
      <v-card-text>
      </v-card-text>
    </template> 
    <template v-if="isEdit">
    <v-form v-model="valid" ref="form">
        <v-card-text>
        <v-layout column>
          <v-flex>
          <v-textarea
            ref="focused"
            label="Название"
            rows="2"
            persistent-hint
            hint="Измените при необходимости название дела"
            v-model="item.nameShort"
          ></v-textarea>          
        </v-flex>
          <v-flex>
          <v-textarea
            ref="focused"
            label="Примечание"
            rows="5"
            persistent-hint
            hint="Показывается во 2-3 строчках списка"
            v-model="item.notes"
          ></v-textarea>          
        </v-flex>
      </v-layout>
      </v-card-text>
      </v-form>
    </template>
    <template #actions>
      <v-btn :disabled='!valid' @click="save">Сохранить</v-btn>
      <v-btn @click="remove">Удалить</v-btn>
      <v-spacer></v-spacer>
    </template>    
  </v-btn-form>
</template>
<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import vBtnForm from '../common/BtnForm'
  // import dialogs from '../common/dialogs'

  export default {
    name: 'assist-form',
    components: {vBtnForm},
    data: () => ({
      edit: true,
      valid: false,
      item: {}
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object,
        default: null
      }
    },
    created () {
      if (!this.model) {
        this.item = this.getItemNew()
      } else {
        this.item.id = this.model.id
        this.item.nameShort = this.model.name
        this.item.notes = this.model.notes
      }
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        calcDialogScroll: 'calcDialogScroll'
      }),
      isEdit () {
        return this.edit || this.isNew
      },
      isNew () {
        return false
      },
      title () {
        return this.isNew ? `Добавление ${this.item.nameShort}` : this.isEdit ? `Атрибуты ${this.item.nameShort}` : `Атрибуты ${this.item.nameShort}`
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('updateAssistMatterName', {id: this.item.id, name: this.item.nameShort, notes: this.item.notes})
          this.edit = false
          this.$emit('input', this.item)
          this.cancel()
        }
      },
      remove () {
        this.$emit('delete')
        this.cancel()
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          id: null,
          nameShort: null,
          notes: ''
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// AssistForm.vue?62e9642b